<template>
	<div class="vipShop " scrollable=""><div class="scrollContentOuterWrapper active" style="width: 624px;">
	<div class="scrollContent" dynamic-height="false" style="width: 644px; overflow-y: auto;">
		<div class="scrollContentInnerWrapper" ng-transclude="" style="width: 624px;">
	<!-- ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="fealtyPoints" data="amount:30" translate=""><span>Ежедневные очки верности</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><div ng-if="(item.currency == 'ad' || !item.cooldownTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" class="packageQuantity contentBox gradient double" data="x:12,y:12" translate=""><span>12/12</span></div><!-- end ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' --><button ng-if="item.currency == 'ad'" clickable="watchAd('1')" class="clickable packageButton" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl || (item.name == 'fealtyPoints' &amp;&amp; (player.data.lastFealtyProduction &lt;= 0 || player.data.fealtyPoints &gt;= maxFealtyPoints || player.data.kingdomId == 0))}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': false, 'Shop.Offer.Button.Unavailable.Tooltip.FealtyLocked': false, 'Shop.Offer.Button.Unavailable.Tooltip.FealtyMax': false, 'Shop.Offer.Button.Unavailable.Tooltip.JoinKingdom': false}"><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel >= item.minPrestigeLvl && (item.name == 'fealtyPoints' && (player.data.lastFealtyProduction <= 0 || player.data.fealtyPoints >= maxFealtyPoints || player.data.kingdomId == 0)) -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel >= item.minPrestigeLvl && (item.name != 'fealtyPoints' || player.data.lastFealtyProduction > 0 && player.data.fealtyPoints < maxFealtyPoints && player.data.kingdomId != 0) --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl &amp;&amp; (item.name != 'fealtyPoints' || player.data.lastFealtyProduction &gt; 0 &amp;&amp; player.data.fealtyPoints &lt; maxFealtyPoints &amp;&amp; player.data.kingdomId != 0)" translate=""><span>Смотреть рекламу</span></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel >= item.minPrestigeLvl && (item.name != 'fealtyPoints' || player.data.lastFealtyProduction > 0 && player.data.fealtyPoints < maxFealtyPoints && player.data.kingdomId != 0) -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage prize_fealtyPoints_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="cage" data="amount:10" translate=""><span>Клетки: 10</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><div ng-if="(item.currency == 'ad' || !item.cooldownTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" class="packageQuantity contentBox gradient double" data="x:5,y:5" translate=""><span>5/5</span></div><!-- end ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' --><button ng-if="item.currency == 'silver'" clickable="redeemOffer('3')" class="clickable packageButton" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl || player.data.silver &lt; item.price}" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': false, 'Error.NotEnoughSilver': false}" currency="silver" price="450"><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" translate=""><span>Купить</span></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage --><span class="price gold" ng-if="price &gt; 0 || forceGoldUsage"><i class="unit_silver_small_illu"></i>450</span><!-- end ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_cage_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="ointment" data="amount:10" translate=""><span>Мази: 10</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><div ng-if="(item.currency == 'ad' || !item.cooldownTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" class="packageQuantity contentBox gradient double" data="x:5,y:5" translate=""><span>5/5</span></div><!-- end ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' --><button ng-if="item.currency == 'silver'" clickable="redeemOffer('4')" class="clickable packageButton" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl || player.data.silver &lt; item.price}" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': false, 'Error.NotEnoughSilver': false}" currency="silver" price="500"><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" translate=""><span>Купить</span></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage --><span class="price gold" ng-if="price &gt; 0 || forceGoldUsage"><i class="unit_silver_small_illu"></i>500</span><!-- end ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_ointment_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="small_bandage" data="amount:10" translate=""><span>Малые повязки: 10</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><div ng-if="(item.currency == 'ad' || !item.cooldownTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" class="packageQuantity contentBox gradient double" data="x:5,y:5" translate=""><span>5/5</span></div><!-- end ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' --><button ng-if="item.currency == 'silver'" clickable="redeemOffer('5')" class="clickable packageButton" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl || player.data.silver &lt; item.price}" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': false, 'Error.NotEnoughSilver': false}" currency="silver" price="200"><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl" translate=""><span>Купить</span></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage --><span class="price gold" ng-if="price &gt; 0 || forceGoldUsage"><i class="unit_silver_small_illu"></i>200</span><!-- end ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_small_bandage_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="book" data="amount:1" translate=""><span>Книга мудрости: 1</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl --><div ng-if="currentPrestigeLevel &lt; item.minPrestigeLvl" class="packageQuantity contentBox gradient double"><i class="symbol_lock_small_flat_black"></i></div><!-- end ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' --><button ng-if="item.currency == 'silver'" clickable="redeemOffer('6')" class="clickable packageButton disabled" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl || player.data.silver &lt; item.price}" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': true, 'Error.NotEnoughSilver': false}" currency="" price=""><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &lt; item.minPrestigeLvl" class="prestige" data="prestige:1000,size:small" translate=""><span>Требуется </span><div class="innerStars" prestige="1000" size="small">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starGold_small_illu"></i>
		<i class="prestigeStar prestige_starGold_small_illu"></i>
		<i class="prestigeStar prestige_starGold_small_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_book_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="finishImmediately" data="amount:2" translate=""><span>Купоны на моментальное завершение: 2</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl --><div ng-if="currentPrestigeLevel &lt; item.minPrestigeLvl" class="packageQuantity contentBox gradient double"><i class="symbol_lock_small_flat_black"></i></div><!-- end ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' --><button ng-if="item.currency == 'gold'" class="clickable premium packageButton disabled" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl}" premium-feature="vipShopOffer" premium-callback-param="7" confirm-gold-usage="true" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': true}" currency="" price=""><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &lt; item.minPrestigeLvl" class="prestige" data="prestige:2000,size:small" translate=""><span>Требуется </span><div class="innerStars" prestige="2000" size="small">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_small_illu"></i><!-- end ngIf: badge -->
</div></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_finishImmediately_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="npcTrader" data="amount:2" translate=""><span>Купоны на сделку с NPC-торговцем: 2</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl --><div ng-if="currentPrestigeLevel &lt; item.minPrestigeLvl" class="packageQuantity contentBox gradient double"><i class="symbol_lock_small_flat_black"></i></div><!-- end ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' --><button ng-if="item.currency == 'gold'" class="clickable premium packageButton disabled" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl}" premium-feature="vipShopOffer" premium-callback-param="8" confirm-gold-usage="true" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': true}" currency="" price=""><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &lt; item.minPrestigeLvl" class="prestige" data="prestige:5000,size:small" translate=""><span>Требуется </span><div class="innerStars" prestige="5000" size="small">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_small_illu"></i><!-- end ngIf: badge -->
</div></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_npcTrader_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="water_bucket" data="amount:1" translate=""><span>Ведра: 1</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl --><div ng-if="currentPrestigeLevel &lt; item.minPrestigeLvl" class="packageQuantity contentBox gradient double"><i class="symbol_lock_small_flat_black"></i></div><!-- end ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' --><button ng-if="item.currency == 'gold'" class="clickable premium packageButton disabled" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl}" premium-feature="vipShopOffer" premium-callback-param="9" confirm-gold-usage="true" ng-attr-currency="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.currency : null}}" ng-attr-price="{{(!item.cooldownTime &amp;&amp; item.booked &lt; item.limitation &amp;&amp; currentPrestigeLevel &gt;= item.minPrestigeLvl) ? item.price : null}}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': true}" currency="" price=""><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &lt; item.minPrestigeLvl" class="prestige" data="prestige:10000,size:small" translate=""><span>Требуется </span><div class="innerStars" prestige="10000" size="small">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_goldBadge_small_illu"></i><!-- end ngIf: badge -->
</div></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage heroItem_water_bucket_large_illu"></div>
	</div><!-- end ngRepeat: item in offers --><div ng-repeat="item in offers" class="packageContainer" ng-class="{featured: item.featured}">
		<div class="premiumPackage hoverHighlight">
			<div class="topDecoration"></div>
			<div class="packageContent">
				<div class="packageContentBox">
					<div class="packageLabel">
						<div class="labelText">
							<span options="gold" data="amount:5" translate=""><span>Золотые монеты: 5</span></span>
						</div>
					</div>

					<div class="packageImageBackground">
						<!-- ngIf: !item.featured --><i ng-if="!item.featured" class="shop_vipOfferBg_large_illu"></i><!-- end ngIf: !item.featured -->
						<!-- ngIf: item.featured -->
					</div>

					<!-- ngIf: (item.currency == 'ad' || !item.cooldownTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
					<!-- ngIf: currentPrestigeLevel < item.minPrestigeLvl --><div ng-if="currentPrestigeLevel &lt; item.minPrestigeLvl" class="packageQuantity contentBox gradient double"><i class="symbol_lock_small_flat_black"></i></div><!-- end ngIf: currentPrestigeLevel < item.minPrestigeLvl -->

					<!-- ngIf: item.currency == 'gold' -->

					<!-- ngIf: item.currency == 'silver' -->

					<!-- ngIf: item.currency == 'candy' -->

					<!-- ngIf: item.currency == 'ad' -->

					<!-- ngIf: item.currency == 'free' --><button ng-if="item.currency == 'free'" clickable="redeemOffer('10')" class="clickable packageButton disabled" ng-class="{disabled: (item.cooldownTime &amp;&amp; item.cooldownTime &gt; $root.currentServerTime) || item.booked &gt;= item.limitation || currentPrestigeLevel &lt; item.minPrestigeLvl}" tooltip="" tooltip-translate-switch="{'Shop.Offer.Button.PrestigeRequired.Tooltip': true}"><div class="content">
	<span ng-transclude="" class="innerText">
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked >= item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl --><span ng-if="(!item.cooldownTime || item.cooldownTime &lt;= $root.currentServerTime) &amp;&amp; currentPrestigeLevel &lt; item.minPrestigeLvl" class="prestige" data="prestige:20000,size:small" translate=""><span>Требуется </span><div class="innerStars" prestige="20000" size="small">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_diamondBadge_small_illu"></i><!-- end ngIf: badge -->
</div></span><!-- end ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && currentPrestigeLevel < item.minPrestigeLvl -->
						<!-- ngIf: (!item.cooldownTime || item.cooldownTime <= $root.currentServerTime) && item.booked < item.limitation && currentPrestigeLevel >= item.minPrestigeLvl -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
						<!-- ngIf: item.cooldownTime && item.cooldownTime > $root.currentServerTime -->
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: item.currency == 'free' -->
				</div>
			</div>
			<div class="bottomDecoration"></div>
		</div>
		<div class="packageImage prize_gold_large_illu"></div>
	</div><!-- end ngRepeat: item in offers -->
</div>
	</div>
</div>
</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>
